import isEqual from 'lodash/isEqual';
import { useEffect } from 'react';
import { usePrevious } from 'react-use';
import { flowsApi } from 'apis/flows';
import { getNodeSchedulesIds } from '../helpers/getNodeScheduleIds';
const initSchedules = [];
export const useScheduleFetch = (actions) => {
    const previousActions = usePrevious(actions);
    const [readSchedules, { schedules }] = flowsApi.useLazyReadFlowsSchedulesBatchQuery({
        selectFromResult: ({ data }) => {
            var _a;
            return ({
                schedules: (_a = data === null || data === void 0 ? void 0 : data.data.schedules) !== null && _a !== void 0 ? _a : initSchedules,
            });
        },
    });
    useEffect(() => {
        if (previousActions === actions)
            return;
        const nodeScheduleIds = getNodeSchedulesIds(actions);
        const previousNodeScheduleIds = getNodeSchedulesIds(previousActions);
        if (!!nodeScheduleIds.length &&
            !isEqual(nodeScheduleIds, previousNodeScheduleIds)) {
            readSchedules({ ids: nodeScheduleIds });
        }
    }, [actions, previousActions, readSchedules]);
    return schedules;
};
